export default __webpack_public_path__ + "static/media/Logo-circle.d5bf94ff.png";